import styled from '@emotion/styled';
import { color } from '@shared/constants/Styles';
import { BodySmall, LabelMedium, TitleXSmall } from './Typography';

/**
 * FormsTypography.tsx
 *
 * This file contains the typography components for forms.
 * They include additional padding and margins to help with the layout of the page.
 * They also include semantic elements for forms.
 * For core typography see Typography.tsx
 */

export const ErrorText = styled(BodySmall)`
    color: ${color.error};
    text-align: center;
`;

export const FieldSetLabel = styled(LabelMedium)`
    color: ${(props) => props.theme.color.text};
    text-align: left;
    margin-bottom: 4px;
    margin-top: 1rem;
`.withComponent('legend');

export const FieldLabel = styled(TitleXSmall)`
    text-align: left;
    margin-bottom: 4px;
    margin-top: 16px;
`.withComponent('label');
